const LessonsActionType = {
  FETCH_ALL_LESSONS: "FETCH_ALL_LESSONS",
  FETCH_SINGLE_LESSON: "FETCH_SINGLE_LESSON",
  ADD_LESSON: "ADD_LESSON",
  EDIT_LESSON: "EDIT_LESSON",
  DELETE_LESSON: "DELETE_LESSON",
  COMPLETE_LESSON: "COMPLETE_LESSON"
};
export default LessonsActionType;